import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';

// Fix Leaflet marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const MapMover = ({ center }) => {
  const map = useMap();
  map.setView(center, 16);
  return null;
};

const Step2 = ({ formData, setFormData }) => {
  const [mapCenter, setMapCenter] = useState([10.3157, 123.8854]); // Default Cebu
  const [markerPos, setMarkerPos] = useState(null);

  const reverseGeocode = async (lat, lng) => {
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`);
      const data = await res.json();
      return data.display_name || `Lat: ${lat}, Lng: ${lng}`;
    } catch (err) {
      console.error(err);
      return `Lat: ${lat}, Lng: ${lng}`;
    }
  };

  const handleSearch = async (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const query = formData.address?.trim();
    if (!query) return;

    try {
      const res = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(query)}`);
      const data = await res.json();

      if (data.features?.length) {
        const [lng, lat] = data.features[0].geometry.coordinates;
        const address = data.features[0].properties.label || query;
        const center = [lat, lng];

        setMapCenter(center);
        setMarkerPos(center);
        setFormData((prev) => ({
          ...prev,
          address,
          mapLocation: { lat, lng, address },
        }));
      } else {
        alert('Address not found.');
      }
    } catch (err) {
      console.error(err);
      alert('Search failed. Please try again.');
    }
  };

  const handleMarkerDragEnd = async (e) => {
    const lat = e.target.getLatLng().lat;
    const lng = e.target.getLatLng().lng;
    const address = await reverseGeocode(lat, lng);
    setMarkerPos([lat, lng]);
    setFormData((prev) => ({
      ...prev,
      address,
      mapLocation: { lat, lng, address },
    }));
  };

  const LocationMarker = () => {
    useMapEvents({
      click: async (e) => {
        const lat = e.latlng.lat;
        const lng = e.latlng.lng;
        const address = await reverseGeocode(lat, lng);
        setMapCenter([lat, lng]);
        setMarkerPos([lat, lng]);
        setFormData((prev) => ({
          ...prev,
          address,
          mapLocation: { lat, lng, address },
        }));
      },
    });

    return markerPos ? (
      <Marker
        position={markerPos}
        draggable={true}
        eventHandlers={{ dragend: handleMarkerDragEnd }}
      />
    ) : null;
  };

  return (
    <div className="card p-4">
      <h5 className="card-title mb-3">Step 2: Address Information</h5>
      <Form>
        {/* Map Search & Display */}
        <hr />
        <h6 className="text-muted mb-3">Enter Complete address and mark in the map</h6>
        <Row>
          <Col md={12}>
            <Form.Control
              type="text"
              placeholder="Search address and press Enter..."
              className="mb-2"
              value={formData.address || ''}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              onKeyDown={handleSearch}
            />

            <MapContainer center={mapCenter} zoom={16} style={{ height: '300px', width: '100%' }}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
              />
              <MapMover center={mapCenter} />
              <LocationMarker />
            </MapContainer>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Step2;
